module.exports = __webpack_public_path__ + "static/media/19121814513814.2ab8b639.jpg";